import React, { useEffect } from "react";

const paragraphs = [
  "Política de privacidad",
  "Objeto",
  "La presente página Web ha sido diseñada para dar a conocer los servicios ofertados por la empresa SINERGY SMK S.L. con CIF B-26765602 con domicilio social en C/ Garcilaso De La Vega 21, Local 12, 38005 Santa Cruz de Tenerife, España.",
  "Propiedad intelectual e industrial",
  "Los derechos de propiedad intelectual de la página WWW.CHACHOPHONE.COM, su código fuente, diseño, estructuras de navegación y los distintos elementos en ella contenidos son titularidad de SINERGY SMK S.L., a quien corresponde el ejercicio exclusivo de los derechos de explotación de los mismos en cualquier forma y, en especial, los derechos de reproducción, distribución, comunicación pública y transformación, de acuerdo con la legislación española y de la Unión Europea aplicable.",
  "Contenidos",
  "Se facilita a través de esta Web información acerca de servicios destinados a conocimiento público que en todo caso se sujetarán a los términos y condiciones expresamente detallados en cada momento y que son accesibles desde esta página Web, los cuales se sujetarán a las distintas disposiciones legales de aplicación.",
  "Acceso y uso",
  "Tanto el acceso a esta página Web, como el uso que pueda hacerse de la información y contenidos incluidos en la misma, será de la exclusiva responsabilidad de quien lo realice. Las condiciones de acceso a este Web estarán supeditadas a la legalidad vigente y los principios de la buena fe y uso lícito por parte del usuario de la misma, quedando prohibido con carácter general cualquier tipo de actuación en perjuicio de SINERGY SMK S.L. Se considerará terminantemente prohibido el uso de la presente página Web con fines ilegales o no autorizados.",
  "Responsabilidad",
  "SINERGY SMK S.L. no se hace responsable bajo ningún concepto por ningún tipo de daño que pudiesen ocasionar los Usuarios a la presente página Web, o a cualquier otra, por el uso ilegal o indebido de la misma, o de los contenidos e informaciones accesibles o facilitadas a través de ella.",
  "Servicio",
  "SINERGY SMK S.L. se reserva el derecho de suspender el acceso a su página Web, sin previo aviso, de forma discrecional y temporal, por razones técnicas o de cualquier otra índole, pudiendo asimismo modificar unilateralmente tanto las condiciones de acceso, como la totalidad o parte de los contenidos en ella incluidos.",
  "Generales",
  "Para toda cuestión litigiosa o que incumba a la Página Web de WWW.CHACHOPHONE.COM, será de aplicación la legislación española, siendo competentes para la resolución de todos los conflictos derivados o relacionados con el uso de esta página Web, los Juzgados y Tribunales del domicilio del usuario. El acceso a la página Web de WWW.CHACHOPHONE.COM implica la aceptación de todas las condiciones anteriormente expresadas.",
  "Hiperenlaces",
  "Los hiperenlaces contenidos en el sitio web de WWW.CHACHOPHONE.COM pueden dirigir a páginas web de terceros. WWW.CHACHOPHONE.COM no asume ninguna responsabilidad por el contenido, informaciones o servicios que pudieran aparecer en dichos sitios, que tendrán exclusivamente carácter informativo y que en ningún caso implican relación alguna entre WWW.CHACHOPHONE.COM y a las personas o entidades titulares de tales contenidos o titulares de los sitios donde se encuentren.",
];

export default function PoliticaPrivacidad() {
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        color: "#000000",
        minHeight: "100vh",
        padding: "48px 24px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ maxWidth: "850px", width: "100%" }}>
        {paragraphs.map((text, i) => (
          <p
            key={i}
            style={{
              fontFamily: "Arial, Helvetica, sans-serif",
              fontWeight: 400,
              fontStyle: "normal",
              fontSize: "16px",
              lineHeight: 1.6,
              color: "#000000",
              margin: "0 0 20px 0",
            }}
          >
            {text}
          </p>
        ))}
      </div>
    </div>
  );
}